import { useToast } from '@cad-arc';
import { createStreamListener, useStream } from '../socket/use-stream';
import { BUTTON_TEXT, DESCRIPTION, MAX_TOAST_TIME } from './constant';
import { useState } from 'react';
import { reloadApp } from '../common/helpers/utils';

export function useRestartNotification() {
    const toast = useToast();
    const [toastId, setToastId] = useState<string | number | undefined>('');

    useStream(
        createStreamListener({
            streamNames: ['restartApplicationNotifications'],
            onMessage() {
                if (toastId) {
                    toast.close(toastId);
                }

                setToastId(
                    toast({
                        status: 'default',
                        description: DESCRIPTION,
                        action: {
                            children: BUTTON_TEXT,
                            onClick() {
                                reloadApp(true);
                            },
                        },
                        duration: MAX_TOAST_TIME, // Infinity, null, undefined does not work and there is no "no expiration" option, so using max number for `setTimeout` according to https://developer.mozilla.org/en-US/docs/Web/API/Window/setTimeout
                    })
                );
            },
        })
    );
}
